import React, { useEffect, useMemo, useState } from "react";
import { LoadingSpinnerBlock } from "../../components/LoadingSpinner";
import Header from "../../Header";
import SideMenu from "../../SideMenu";
import Footer from "../../Footer";
import api from "../../services/api";
import DataTable from "react-data-table-component";

import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Title,
  BarElement,
  LinearScale,
  CategoryScale,
  Legend,
} from "chart.js";

ChartJS.register(
  ArcElement,
  Tooltip,
  CategoryScale,
  LinearScale,
  BarElement,
  Legend,
  Title
);

const MOBILE_BREAKPOINT = "(max-width: 768px)";

export default function Painel({ history }) {
  const [treinamentos, setTreinamentos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [imglogo, setImglogo] = useState('');
  const [isIntegracao, setIsIntegracao] = useState(false);
  const [isMobileLayout, setIsMobileLayout] = useState(() =>
    typeof window !== "undefined" &&
    window.matchMedia(MOBILE_BREAKPOINT).matches
  );

  const userid = localStorage.getItem('sgiuserid');
  const userempresaid = localStorage.getItem('sgiempresaid');

  const url_string = window.location.href;
  const param = url_string.split("?");

  const checkValidUser = async () => {
    const userId = localStorage.getItem("sgiuserid");
    const response = await api.get("/treinamentos/usuarios/" + userId);
    const data = await response.data;
    if (typeof data[0] !== "object") {
      localStorage.clear();
      history.push("/login");
    }
  };

  const goToPage = async (state) => {
    history.push("/treinamento/" + state._id);
  };

  async function loadTreinamentos() {
    setLoading(true);
    try {
      const query = "/treinamentos/produtocliente/usuario/" + userid;
      const response = await api.get(query);
      const data = await response.data;

      if (param[1] == "integracao=1") {
        setTreinamentos(
          data.filter((treinamento) => treinamento.isIntegracao == true)
        );
      } else {
        setTreinamentos(
          data.filter((treinamento) => treinamento.isIntegracao == false)
        );
      }
    } finally {
      setLoading(false);
    }
  }


  async function loadEmpresa() {
    if(userid === null){
      return
    }
    const query = '/treinamentos/empresa/' + userempresaid;
    const response = await api.get(query);
    const data = await response.data;
    if(data){
      if(data[0].nome == 'Keishi LTDA'){
        setImglogo("keishi.png")
        return
      }
      if(data[0].nome == 'Supergelados LTDA'){
        setImglogo("supergelados.png")
      }
    }
  };

  const columns = useMemo(
    () => [
      {
        name: "Titulo",
        selector: (row) => row.titulo,
        wrap: true,
        sortable: true,
        minWidth: "160px",
        grow: 2,
      },
      {
        name: "Progresso",
        selector: (row) => Math.round(row.progresso) + "%",
        sortable: false,
        minWidth: "88px",
        center: true,
      },
      {
        name: "Status",
        cell: (row) => <CustomStatus row={row} />,
        sortable: false,
        minWidth: "100px",
        allowOverflow: true,
      },
      {
        name: "Prazo",
        cell: (row) => <CustomDate row={row} />,
        sortable: false,
        minWidth: "96px",
      },
      {
        name: "Concluido em",
        cell: (row) => <CustomConcluido row={row} />,
        sortable: false,
        minWidth: "108px",
      },
      {
        name: "Ação",
        cell: (row) => <CustomAcoes row={row} />,
        sortable: false,
        minWidth: "168px",
        allowOverflow: true,
      },
    ],
    []
  );

  const CustomDate = ({ row }) =>
  new Date(row.dataDueDate).toLocaleDateString('pt-BR')
  

  const CustomConcluido = ({ row }) =>
  row.dataFinalizado ?
   new Date(row.dataFinalizado).toLocaleDateString('pt-BR')
   :
   "-"

  const stopRowNav = (e) => {
    e.stopPropagation();
  };

  const CustomAcoes = ({ row }) =>
    row.progresso == 0 ? (
      <button
        type="button"
        className="btn btn-success btn-sm"
        onClick={(e) => {
          stopRowNav(e);
          history.push("/treinamento/" + row._id);
        }}
      >
        Iniciar Treinamento
      </button>
    ) : row.progresso > 0 && row.progresso < 100 ? (
      <button
        type="button"
        className="btn btn-success btn-sm"
        onClick={(e) => {
          stopRowNav(e);
          history.push("/treinamento/" + row._id);
        }}
      >
        Continuar Treinamento
      </button>
    ) : row.progresso == 100 && !row.dataFinalizado ? (
      <button
        type="button"
        className="btn btn-warning btn-sm"
        onClick={(e) => {
          stopRowNav(e);
          history.push("/avaliacao/" + row._id);
        }}
      >
        Realizar Avaliação
      </button>
    ) : row.dataFinalizado ? (
      <a
        className="btn btn-info btn-sm"
        href={row.linkCertificado}
        target="_blank"
        rel="noopener noreferrer"
        onClick={stopRowNav}
      >
        Acessar Certificado
      </a>
    ) : (
      ""
    );

  const CustomStatus = ({ row }) =>
    row.status == 1 ? (
      <span className="label label-success">Finalizado</span>
    ) : (
      <span className="label label-danger">Pendente</span>
    );

  async function downloadPDF(pdflink){
    setLoading(true);
    window.open(pdflink);
    setLoading(false);

  };
  
  useEffect(() => {
    const mq = window.matchMedia(MOBILE_BREAKPOINT);
    const sync = () => setIsMobileLayout(mq.matches);
    sync();
    mq.addEventListener("change", sync);
    return () => mq.removeEventListener("change", sync);
  }, []);

  useEffect(() => {
    document.body.className = "skin-blue sidebar-mini"
    checkValidUser();
    if(userid === null)
    window.location.href = "/login"; 
    //loadProgresso();
    loadTreinamentos();
    loadEmpresa();
    if(param[1] == 'integracao=1'){
      setIsIntegracao(true);
      setTimeout(() => {
            if (document.getElementById("menu_painel_integracao")) {
              document.getElementById("menu_painel_integracao").className = "active";
            }
      }, 50);
    } else {
      setTimeout(() => {
        if (document.getElementById("menu_painel")) {
          document.getElementById("menu_painel").className = "active";
        }
      }, 50);
    }
  }, []);

  return (
    <>
      <Header />
      <SideMenu />

      <div className="content-wrapper">
        {/* Main content */}
        <section className="content">
          <div className="row">
            <div className="col-xs-12">
              <div className="box box-primary painel-treinamentos-box">
              <div className="box-body">
                <div className="admin-courses-tab">
                  <h3 className="title">{isIntegracao == true ? "Minha Integração" : "Meus Treinamentos"}</h3>
                </div>

                {loading ? (
                  <LoadingSpinnerBlock size={56} hint="Carregando treinamentos…" />
                ) : (
                  <>
                    {!isMobileLayout && (
                      <div className="painel-datatable-scroll painel-datatable-scroll--desktop">
                        <DataTable
                          className="painel-rdt"
                          keyField="_id"
                          columns={columns}
                          data={treinamentos}
                          onRowClicked={goToPage}
                          pointerOnHover
                          highlightOnHover
                          responsive={false}
                          noDataComponent={""}
                        />
                      </div>
                    )}

                    {isMobileLayout && treinamentos.length > 0 && (
                      <ul className="painel-treinamentos-cards list-unstyled">
                        {treinamentos.map((row) => (
                          <li key={row._id}>
                            <div
                              className="painel-treinamento-card"
                              onClick={() => goToPage(row)}
                            >
                              <div className="painel-treinamento-card__title">
                                {row.titulo}
                              </div>
                              <div
                                className="painel-treinamento-card__progress"
                                aria-hidden="true"
                              >
                                <div
                                  className="painel-treinamento-card__progress-bar"
                                  style={{
                                    width: `${Math.min(100, Math.max(0, Math.round(row.progresso)))}%`,
                                  }}
                                />
                              </div>
                              <div className="painel-treinamento-card__meta">
                                <div className="painel-treinamento-card__row">
                                  <span className="painel-treinamento-card__label">
                                    Progresso
                                  </span>
                                  <span>{Math.round(row.progresso)}%</span>
                                </div>
                                <div className="painel-treinamento-card__row">
                                  <span className="painel-treinamento-card__label">
                                    Status
                                  </span>
                                  <span>
                                    <CustomStatus row={row} />
                                  </span>
                                </div>
                                <div className="painel-treinamento-card__row">
                                  <span className="painel-treinamento-card__label">
                                    Prazo
                                  </span>
                                  <span>
                                    <CustomDate row={row} />
                                  </span>
                                </div>
                                <div className="painel-treinamento-card__row">
                                  <span className="painel-treinamento-card__label">
                                    Concluído em
                                  </span>
                                  <span>
                                    <CustomConcluido row={row} />
                                  </span>
                                </div>
                              </div>
                              <div
                                className="painel-treinamento-card__actions"
                                onClick={(e) => e.stopPropagation()}
                                onKeyDown={(e) => e.stopPropagation()}
                              >
                                <CustomAcoes row={row} />
                              </div>
                            </div>
                          </li>
                        ))}
                      </ul>
                    )}

                    {treinamentos.length < 1 && (
                      <div
                        style={{
                          textAlign: "center",
                          padding: "40px",
                          color: "#666",
                        }}
                      >
                        <i
                          className="fa fa-inbox"
                          style={{
                            fontSize: "48px",
                            marginBottom: "15px",
                            opacity: 0.5,
                          }}
                        ></i>
                        <p style={{ fontSize: "16px", margin: 0 }}>
                          Nenhum treinamento disponível no momento.
                        </p>
                      </div>
                    )}
                  </>
                )}
              </div>
              </div>
            </div>
          </div>

        </section>
        {/* /.content */}
      </div>

      <Footer />
    </>
  );
}
